import autobind from 'autobind-decorator';
import { computed, extendObservable, toJS } from 'mobx';

@autobind
class TeamGameStatModel {
  constructor(data) {
    extendObservable(this, data);
  }
  @computed
  get chart() {
    const {
      shooting,
      shotsOnTarget,
      foul,
      corner,
      freeKick,
      offside,
      yellowCardCount,
      redCardCount,
      possession,
      save,
      interception1,
      tackle,
      missedShot,
      blockedShot,
      passAttempted,
      passCompleted,
      interception2,
      attack,
      dangerousAttack,
      expectedGoal,
      bigChance,
      hitWoodwork,
      shotInsideBox,
      shotOutsideBox,
      touchOpponentBox,
    } = this;

    let result = {
      shooting: { p: 0, v: '' },
      shotsOnTarget: { p: 0, v: '' },
      foul: { p: 0, v: '' },
      corner: { p: 0, v: '' },
      freeKick: { p: 0, v: '' },
      offside: { p: 0, v: '' },
      yellowCardCount: { p: 0, v: '' },
      redCardCount: { p: 0, v: '' },
      possession: { p: 0, v: '' },
      save: { p: 0, v: '' },
      interception1: { p: 0, v: '' },
      tackle: { p: 0, v: '' },
      missedShot: { p: 0, v: '' },
      blockedShot: { p: 0, v: '' },
      passAttempted: { p: 0, v: '' },
      passCompleted: { p: 0, v: '' },
      interception2: { p: 0, v: '' },
      attack: { p: 0, v: '' },
      dangerousAttack: { p: 0, v: '' },
      expectedGoal: { p: 0, v: '' },
      bigChance: { p: 0, v: '' },
      hitWoodwork: { p: 0, v: '' },
      shotInsideBox: { p: 0, v: '' },
      shotOutsideBox: { p: 0, v: '' },
      touchOpponentBox: { p: 0, v: '' },
    };

    if (!!shooting) {
      const percent = +((shooting / 50) * 100).toFixed(1);

      result.shooting = {
        p: percent > 100 ? 100 : percent,
        v: shooting,
      };
    }

    if (shotsOnTarget) {
      const percent = +((shotsOnTarget / 50) * 100).toFixed(1);

      result.shotsOnTarget = {
        p: percent > 100 ? 100 : percent,
        v: shotsOnTarget,
      };
    }

    if (foul) {
      const percent = +((foul / 50) * 100).toFixed(1);

      result.foul = {
        p: percent > 100 ? 100 : percent,
        v: foul,
      };
    }

    if (corner) {
      const percent = +((corner / 50) * 100).toFixed(1);

      result.corner = {
        p: percent > 100 ? 100 : percent,
        v: corner,
      };
    }

    if (freeKick) {
      const percent = +((freeKick / 50) * 100).toFixed(1);

      result.freeKick = {
        p: percent > 100 ? 100 : percent,
        v: freeKick,
      };
    }

    if (offside) {
      const percent = +((offside / 30) * 100).toFixed(1);

      result.offside = {
        p: percent > 100 ? 100 : percent,
        v: offside,
      };
    }

    if (yellowCardCount) {
      const percent = +((yellowCardCount / 30) * 100).toFixed(1);

      result.yellowCardCount = {
        p: percent > 100 ? 100 : percent,
        v: yellowCardCount,
      };
    }

    if (redCardCount) {
      const percent = +((redCardCount / 10) * 100).toFixed(1);

      result.redCardCount = {
        p: percent > 100 ? 100 : percent,
        v: redCardCount,
      };
    }

    if (possession) {
      const percent = +((possession / 50) * 100).toFixed(1);

      result.possession = {
        p: percent > 100 ? 100 : percent,
        v: possession,
      };
    }

    if (save) {
      const percent = +((save / 20) * 100).toFixed(1);

      result.save = {
        p: percent > 100 ? 100 : percent,
        v: save,
      };
    }

    if (interception1) {
      const percent = +((interception1 / 50) * 100).toFixed(1);

      result.interception1 = {
        p: percent > 100 ? 100 : percent,
        v: interception1,
      };
    }

    if (tackle) {
      const percent = +((tackle / 50) * 100).toFixed(1);

      result.tackle = {
        p: percent > 100 ? 100 : percent,
        v: tackle,
      };
    }

    if (missedShot) {
      const percent = +((missedShot / 20) * 100).toFixed(1);

      result.missedShot = {
        p: percent > 100 ? 100 : percent,
        v: missedShot,
      };
    }

    if (blockedShot) {
      const percent = +((blockedShot / 20) * 100).toFixed(1);

      result.blockedShot = {
        p: percent > 100 ? 100 : percent,
        v: blockedShot,
      };
    }

    if (passAttempted) {
      const percent = +((passAttempted / 1000) * 100).toFixed(1);

      result.passAttempted = {
        p: percent > 100 ? 100 : percent,
        v: passAttempted,
      };
    }

    if (passCompleted) {
      const percent = +((passCompleted / 1000) * 100).toFixed(1);

      result.passCompleted = {
        p: percent > 100 ? 100 : percent,
        v: passCompleted,
      };
    }

    if (interception2) {
      const percent = +((interception2 / 50) * 100).toFixed(1);

      result.interception2 = {
        p: percent > 100 ? 100 : percent,
        v: interception2,
      };
    }

    if (attack) {
      const percent = +((attack / 200) * 100).toFixed(1);

      result.attack = {
        p: percent > 100 ? 100 : percent,
        v: attack,
      };
    }

    if (dangerousAttack) {
      const percent = +((dangerousAttack / 100) * 100).toFixed(1);

      result.dangerousAttack = {
        p: percent > 100 ? 100 : percent,
        v: dangerousAttack,
      };
    }

    if (expectedGoal) {
      const percent = expectedGoal * 10;

      result.expectedGoal = {
        p: percent > 100 ? 100 : percent,
        v: expectedGoal,
      };
    }

    if (bigChance) {
      const percent = +((bigChance / 20) * 100).toFixed(1);

      result.bigChance = {
        p: percent > 100 ? 100 : percent,
        v: bigChance,
      };
    }

    if (hitWoodwork) {
      const percent = +((hitWoodwork / 50) * 100).toFixed(1);

      result.hitWoodwork = {
        p: percent > 100 ? 100 : percent,
        v: hitWoodwork,
      };
    }

    if (shotInsideBox) {
      const percent = +((shotInsideBox / 30) * 100).toFixed(1);

      result.shotInsideBox = {
        p: percent > 100 ? 100 : percent,
        v: shotInsideBox,
      };
    }

    if (shotOutsideBox) {
      const percent = +((shotOutsideBox / 30) * 100).toFixed(1);

      result.shotOutsideBox = {
        p: percent > 100 ? 100 : percent,
        v: shotOutsideBox,
      };
    }

    if (touchOpponentBox) {
      const percent = +((touchOpponentBox / 50) * 100).toFixed(1);

      result.touchOpponentBox = {
        p: percent > 100 ? 100 : percent,
        v: touchOpponentBox,
      };
    }

    // // 야투
    // if (!!fieldGoalsPercentage) {
    //   result.fieldGoalsPercentage = {
    //     p: fieldGoalsPercentage > 100 ? 100 : fieldGoalsPercentage,
    //     v: `${Math.floor(+fieldGoalsPercentage)}%`
    //   };
    // }
    //
    // // 3점슛
    // if (!!threePointFieldGoalsPercentage) {
    //   result.threePointFieldGoalsPercentage = {
    //     p:
    //       threePointFieldGoalsPercentage > 100
    //         ? 100
    //         : threePointFieldGoalsPercentage,
    //     v: `${Math.floor(threePointFieldGoalsPercentage)}%`
    //   };
    // }
    //
    // // 자유투
    // if (!!freeThrowsPercentage) {
    //   result.freeThrowsPercentage = {
    //     p: freeThrowsPercentage > 100 ? 100 : freeThrowsPercentage,
    //     v: `${Math.floor(+freeThrowsPercentage)}%`
    //   };
    // }
    //
    // //  어시스트
    // if (!!assists) {
    //   const value = +((assists / 30) * 100).toFixed(1);
    //
    //   result.assists = {
    //     p: value > 100 ? 100 : value,
    //     v: assists
    //   };
    // }
    //
    // //  리바운드
    // if (!!reboundsTotal) {
    //   const value = +((reboundsTotal / 50) * 100).toFixed(1);
    //
    //   result.reboundsTotal = {
    //     p: value > 100 ? 100 : value,
    //     v: reboundsTotal
    //   };
    // }
    //
    // //  스틸
    // if (!!steals) {
    //   const value = +((steals / 10) * 100).toFixed(1);
    //
    //   result.steals = {
    //     p: value > 100 ? 100 : value,
    //     v: steals
    //   };
    // }
    //
    // //  블록
    // if (!!blockedShots) {
    //   const value = +((blockedShots / 10) * 100).toFixed(1);
    //
    //   result.blockedShots = {
    //     p: value > 100 ? 100 : value,
    //     v: blockedShots
    //   };
    // }
    //
    // //  턴오버
    // if (!!turnoversTotal) {
    //   const value = +((turnoversTotal / 30) * 100).toFixed(1);
    //
    //   result.turnoversTotal = {
    //     p: value > 100 ? 100 : value,
    //     v: turnoversTotal
    //   };
    // }

    return result;
  }
}

export default TeamGameStatModel;
